﻿import $ from 'jquery';
import { HandlesWindowNavigation } from './handleswindownavigation';

declare global {
  interface JQuery {
    navigate: (object, args) => any;
  }
}

export class Navigate {

  public static get wireup(): string {
    return '[data-navigate]'
  }

  private DEFAULTS: NavigateOptions = {
    url: undefined,
    on: 'click',
    target: '_self'
  };

  private $element: JQuery;
  private options: NavigateOptions;

  public constructor($element: JQuery, options?: NavigateOptions) {
    this.$element = $element;
    this.options = $.extend({}, this.DEFAULTS, this.getOptions(), options)
    this.wireupEvents();
  }

  private wireupEvents() {
    if (this.options.on == 'click') {
      this.$element.on('click', (e: JQueryEventObject) => this.navigateToUrl(e));
    }
    else if (this.options.on == 'doubleclick') {
      this.$element.on('dblclick', (e: JQueryEventObject) => this.navigateToUrl(e));
    }
  }

  private getOptions(): NavigateOptions {
    return {
      url: this.$element.data('navigate'),
      on: this.$element.data('navigate-on'),
      target: this.$element.data('navigate-target')
    };
  }

  private navigateToUrl(e: JQueryEventObject): void {
    var isRemote = this.$element.is('[data-remote]');
    var isTargetAnchor = $(e.target).is('a');

    if (isTargetAnchor)
      return;

    if (isRemote) {
      this.$element.remote({ url: this.options.url });
      e.preventDefault();
      e.stopPropagation();
    }
    else {
      HandlesWindowNavigation.execute({
        url: this.options.url,
        target: this.options.target
      });
    }
  }
}

export interface NavigateOptions {
  url: string,
  on: string,
  target: string
}

function Plugin(option, args) {
  return this.each(function () {
    let $this = $(this);
    let data = $this.data('rustig.navigate');
    let options = typeof option == 'object' && option;

    if (!data) {
      data = new Navigate($this, options);
      $this.data('rustig.navigate', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.navigate = Plugin;
